const { addEventListener, cancelAnimationFrame, requestAnimationFrame, scrollTo } = window
const scrollY: () => number = (): number => window.scrollY

type ScrollEdge = "top" | "bottom"

interface ScrollOptions {
    behavior?: ScrollEdge
    /** The scroll animation time in milliseconds */
    duration?: number
    /** The final scroll offset from the element in pixels */
    offset?: number
}

const getAbsoluteElementOffsetY: (element: HTMLElement, bottomEdge: boolean) => number = (
    element: HTMLElement,
    bottomEdge: boolean,
): number => {
    const clientRect: DOMRect = element.getBoundingClientRect()

    if (!bottomEdge) {
        return clientRect.top + scrollY()
    }

    return clientRect.top + clientRect.height + scrollY()
}

let rafIndex = -1

addEventListener(
    "wheel",
    (): void => {
        if (rafIndex >= 0) {
            cancelAnimationFrame(rafIndex)
            rafIndex = -1
        }
    },
    { passive: true },
)

export function scrollToElement(element: HTMLElement, options?: ScrollOptions): void {
    const duration: number = options?.duration || 0
    const scrollToBottomEdge: boolean = options?.behavior === "bottom"
    const targetY: number = getAbsoluteElementOffsetY(element, scrollToBottomEdge)
    const startY: number = scrollY()
    const distance: number = targetY - startY - (options?.offset || 0)

    if (rafIndex >= 0) {
        cancelAnimationFrame(rafIndex)
        rafIndex = -1
    }

    if (duration <= 0 || distance === 0) {
        scrollTo(0, targetY)
        return
    }

    const startTime: number = performance.now()

    function easeProgress(t: number): number {
        return t // t * (2 - t) // easeOutQuad
    }

    function step(): void {
        const elapsed: number = performance.now() - startTime
        const progress: number = Math.min(elapsed / duration, 1)
        const easedProgress: number = easeProgress(progress)

        scrollTo(0, startY + distance * easedProgress)

        if (progress < 1) {
            rafIndex = requestAnimationFrame(step)
        } else {
            rafIndex = -1
        }
    }

    rafIndex = requestAnimationFrame(step)
}
